module.exports = __webpack_public_path__ + "img/portallogin.2791ba17.svg";